import { StoreFinderButton as StoreFinderButtonBase } from "@omni/components/components/Navigation/Buttons/StoreFinderButton/storeFinderButton";
import { StoreFinderButtonProps } from "@omni/types/components/props/storeFinderButton.props";
import { BaseStore } from "@omni/types/enums/baseStore.enum";

import { StoreFinderButtonComponent } from "@/components/Navigation/Buttons/StoreFinderButton/storeFinderButton.component";

export const StoreFinderButton = ({
    icon,
    alerts,
    invert,
    invertMobile,
    link,
    ariaLabel,
    text,
    textHidden
}: StoreFinderButtonProps<BaseStore.Etna>) => {
    return (
        <StoreFinderButtonBase
            icon={icon}
            alerts={alerts}
            invert={invert}
            invertMobile={invertMobile}
            link={link}
            ariaLabel={ariaLabel}
            text={text}
            textHidden={textHidden}
        >
            <StoreFinderButtonComponent />
        </StoreFinderButtonBase>
    );
};
